<template>
  <div class="app-wrapper">
    <HeaderWrapper @navTo="(target) => setPage(target)" :profile="profile" @open-my-reports="openMyReports" />
    <div class="page-container">
      <!-- <SideBar class="sidebar" @plotSelected="updateSelectedPlot" @sidebar-toggled="onSidebarToggled"/> -->

      <div class="page-contents">
        <div class="application-container" v-if="selectedPlot === 'Sound Pressure Levels'">
          <SoundPressureLevels ref="soundPressureLevels" :initialParams="requestParams" :profile="profile" />
        </div>

        <div class="application-container" v-else-if="selectedPlot === 'Review Requests'">
          <ReviewRequests ref="reviewRequests" @navigate="
            (site, unit_id, dt) => handleSplParamRequest(site, unit_id, dt)
          " />
        </div>

        <div class="application-container" v-else-if="selectedPlot === 'UserDocs'">
          <UserDocs ref="userDocs" />
        </div>

        <div class="application-container" v-else-if="selectedPlot === 'Modelling'" ref="modelling" @navigate="
          (site, unit_id, dt) => handleSplParamRequest(site, unit_id, dt)
        ">
          <ModellingPage @navigate="
            (site, sxId, dt) => handleSplParamRequest(site, sxId, dt)
          " />
        </div>
      </div>
    </div>
    <!-- <TestingComponent /> -->
  </div>
  <MyReports v-if="showMyReports" :user-profile="currentUserProfile"
  @close_my_reports="closeMyReports"/>
</template>

<script lang="js">
// import SideBar from "./components/SideBar.vue";
import HeaderWrapper from "./components/HeaderWrapper.vue";
import SoundPressureLevels from './components/SoundPressureLevels.vue'
import ReviewRequests from './components/ReviewRequests.vue'
import ModellingPage from './components/ModellingPage.vue'
import UserDocs from './components/UserDocs.vue'
import MyReports from './components/MyReports.vue'
// import { useKeycloak } from '@josempgon/vue-keycloak'
import { useKeycloak } from './keycloak-wrapper'
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart, RadarChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  MarkLineComponent,
  MarkAreaComponent,
} from "echarts/components";

use([
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  LineChart,
  CanvasRenderer,
  MarkLineComponent,
  MarkAreaComponent,
  RadarChart,
]);

export default {
  components: {
    HeaderWrapper,
    UserDocs,
    // SideBar,
    SoundPressureLevels,
    ReviewRequests,
    ModellingPage,
    MyReports,
  },
  data() {
    return {
      showMyReports: false,
      currentUserProfile: null,
      selectedPlot: "Sound Pressure Levels",
      requestParams: {},
      profile: {}, //keycloak profile
      isAuthenticated: null,
    };
  },
  methods: {
    openMyReports() {
      this.currentUserProfile = this.profile;
      this.showMyReports = true;

    },
    closeMyReports() {
      this.showMyReports = false;
      this.currentUserProfile = null;
    },

    handleSplParamRequest(site, unit_id, dt) {
      this.requestParams = {
        date_time: dt,
        unit_ID: unit_id,
        site: site
      },
        this.setPage('Sound Pressure Levels');
    },
    async setPage(plot) {
      this.selectedPlot = plot
    },

    async reloadComponents() {
      const components = [
        this.$refs.weightedSpectra,
        this.$refs.tonalNoise,
        this.$refs.lowFrequencyNoise,
        this.$refs.soundClassifications,
        this.$refs.soundPressureLevels,
        this.$refs.gradcams
      ].filter(component => component); // Filter out undefined components

      // Await all reload promises
      await Promise.all(components.map(component => component.reload()));
    },
    async onSidebarToggled() {
      // setTimeout(() => this.reloadComponents(), 5);
    },
    async waitForProfile(maxAttempts = 10, interval = 500) {
      return new Promise((resolve, reject) => {
        let attempts = 0;
        const checkProfile = async () => {
          try {
            const profile = await useKeycloak();
            this.isAuthenticated = profile?.isAuthenticated.value;
            if (!this.isAuthenticated) {
              throw Error("profile not authenticated or initialised")
            }
            clearInterval(timer); // Stop retries
            resolve(profile);
          } catch (error) {
            attempts++;
            console.log(`Attempt ${attempts}: profile not available, retrying...`);
            if (attempts >= maxAttempts) {
              clearInterval(timer);
              reject(new Error('Failed to retrieve token within allowed attempts.'));
            }
          }
        };

        const timer = setInterval(checkProfile, interval);
        checkProfile(); // Try immediately
      });
    },
    async updateDetails() {
      try {
        this.profile = await this.waitForProfile();
        // console.log('profile', profile)

      } catch (error) {
        console.error(error.message);
      }
    },
  },
  mounted() {
    document.title = "Virtual Acoustician";
    this.updateDetails();
    // window.addEventListener('resize', this.reloadComponents);
  },

};
</script>

<style>
@font-face {
  font-family: "Gilroy";
  src: url("@/assets/fonts/Gilroy-Bold.ttf") format("truetype");
}

@font-face {
  font-family: "Gilroy";
  src: url("@/assets/fonts/Gilroy-Light.ttf") format("truetype");
}

@font-face {
  font-family: "Gilroy";
  src: url("@/assets/fonts/Gilroy-Medium.ttf") format("truetype");
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--colour-navy);
  width: 100%;
}

.app-wrapper {
  width: 100%;
}

.page-container {
  /* display: flex; */
  width: calc(100vw);
  height: calc(100vh - var(--header-height));
  grid-template-columns: auto auto;
  white-space: nowrap;
}

.page-contents {
  width: 100%;
  height: 100%;
  background-color: var(--colour-bg-light);
}

.application-container {
  width: 100%;
  height: 100%;
  /* display: grid;
  grid-template-columns: repeat(1, 1fr);  */
  /* grid-gap: 10px; */
}

.bar-plot-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: var(--spacing-lg);
  /* Adds space between each plot container */
}

.inspector {
  background-color: #adadad;
}

.dropdown-site,
.dropdown-unit {
  /* Adjust the margin as needed */
  font-size: 5em !important;
  font-weight: bold;
  display: flex;
  align-items: center;
  padding: var(--spacing-2xs);
  height: var(--control-height-lg);
}

.dropdown-site {
  width: 12.5rem;
}

.dropdown-unit {
  width: 9.375rem;
}

.selection-group {
  margin-right: var(--spacing-lg);
  /* Adjust the margin as needed */
  font-size: 0.95em !important;
  display: flex;
  align-items: center;
  padding: var(--spacing-2xs);
  height: var(--control-height-lg);
}

.data-loading {
  background-color: var(--colour-bg-light);
  width: 80%;
  margin: auto;
}

.data-loading p {
  font-size: 1.3em;
}

#unitDropdown {
  width: 3.125rem;
}

.card {
  background: var(--surface-card);
  padding: 2rem;
  border-radius: var(--radius-md);
  margin-bottom: 1rem;
}

.datepicker {
  display: flex;
}

.p-link {
  /* fix for calendar offset issue */
  margin: auto;
}

.p-button {
  /* simillarly */
  margin: 0;
}

/* .LFN-container {
  display: flexbox;
  margin: 50px;
} */
/* .bar-plot-container {
  display: flex;
} */

button {
  font-size: 1.1em;
  height: var(--control-height-lg);
}

.icon {
  font-size: var(--font-size-xl);
}

.available {
  color: green;
}

.icon-warning {
  color: orange;
}

.unavailable {
  color: red;
}

.tooltip-icon {
  font-size: 0.7em;
  /* Superscript offset — scales with font size */
  vertical-align: 0.4em;
  margin-left: var(--spacing-xs);
  cursor: pointer;
  color: var(--colour-info);
}

.warning-container {
  margin-top: 175px;
  width: 100%;
}

.warning {
  font-size: 2em;
  padding: 25px;
  margin: var(--spacing-2xl);
  color: red;
  border: 2px solid var(--colour-border-strong);
}

.audio-player-app-container {
  width: 90%;
  margin: auto;
  padding-top: 60px;
  padding: 15px;
  /* border: 2px solid #555;
  border-radius: 15px; */
}

.lds-dual-ring,
.lds-dual-ring:after {
  box-sizing: border-box;
}

.lds-dual-ring {
  display: flex;
  width: auto;
  height: auto;
}

.lds-dual-ring:after {
  content: " ";
  display: block;
  width: var(--icon-size-md);
  height: var(--icon-size-md);
  margin: var(--spacing-2xs);
  border-radius: 50%;
  border: 2.4px solid var(--colour-info);
  border-color: var(--colour-info) transparent var(--colour-info) transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
